import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { useTranslation } from 'react-i18next';

const NoScheduledEmails = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.scheduledEmails.noData.primary')}
            secondary={t('prompts:noData.scheduledEmails.noData.secondary')}
            Icon="schedule_send"
        />
    );
};

export default NoScheduledEmails;
